import { useState as m, useCallback as a } from "react";
const y = (i) => {
  const [r, n] = m(!1), l = a(() => {
    const e = i.current;
    if (!e)
      return;
    e.style.overflow = "hidden", e.style.transition = "none", e.style.maxHeight = "0px", e.style.opacity = "0", n(!0);
    const s = e.scrollHeight;
    requestAnimationFrame(() => {
      e.style.transition = "max-height 300ms cubic-bezier(0.4, 0, 0.2, 1), opacity 300ms ease-out", e.style.maxHeight = `${s}px`, e.style.opacity = "1";
      const t = (o) => {
        o.propertyName === "max-height" && (e.style.maxHeight = "none", e.style.overflow = "visible", e.removeEventListener("transitionend", t), n(!1));
      };
      e.addEventListener("transitionend", t);
    });
  }, [i]), c = a(() => {
    const e = i.current;
    if (!e)
      return;
    const s = e.scrollHeight;
    e.style.maxHeight = `${s}px`, e.style.overflow = "hidden", e.style.transition = "max-height 300ms cubic-bezier(0.4, 0, 0.2, 1), opacity 300ms ease-out", e.style.opacity = "1", requestAnimationFrame(() => {
      e.style.maxHeight = "0px", e.style.opacity = "0";
      const t = (o) => {
        o.propertyName === "max-height" && (e.removeEventListener("transitionend", t), n(!1));
      };
      e.addEventListener("transitionend", t);
    });
  }, [i]);
  return { show: l, hide: c, isAnimating: r };
};
export {
  y as useMobileNavigationToggle
};
